const DATABASE_OR_STACK_TEXT = [
  /\b[a-z][a-z0-9]*(?:_[a-z0-9]+)+\b/iu,
  /\b(?:statement timeout|canceling statement|deadlock detected|could not serialize access|current transaction is aborted)\b/iu,
  /\b(?:duplicate key|unique constraint|foreign key|violates|permission denied|table|column|relation|sqlstate|postgres|database)\b/iu,
  /\b(?:invalid input syntax|syntax error at|operator does not exist)\b/iu,
  /\bPGRST\d+\b/iu,
  /^[0-9A-Z]{5}$/iu,
  /\b(?:TypeError|ReferenceError|SyntaxError|RangeError|Error):/u,
];

function isDatabaseOrStackText(value: string): boolean {
  return DATABASE_OR_STACK_TEXT.some((pattern) => pattern.test(value));
}

/**
 * Messages written for people in this codebase are sentences: a capital first
 * letter and closing punctuation ("Client is required."). PostgreSQL and driver
 * messages are lower-case fragments with no full stop ("value too long for type
 * character varying(255)", "numeric field overflow"). Requiring the sentence
 * shape makes the check reject by default: text that is not recognisably
 * authored copy falls back to the generic failure, whether or not it matches
 * one of the known database phrases above.
 */
function isAuthoredSentence(value: string): boolean {
  return /^[A-Z][^\n]{2,240}[.!?]$/u.test(value);
}

/** A plain authored sentence with no database or stack text: safe to show a person. */
export function isUserSafeReason(value: string): boolean {
  return isAuthoredSentence(value) && !isDatabaseOrStackText(value);
}
